var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenPassword = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5199 4.62268V16.6547H8.5V36.6227H32.447L32.5 16.6547H26.6215V4.62268H14.5199ZM24.5973 6.64421V16.6547H16.5442V6.64421H24.5973ZM10.542 34.6012H30.4315L30.4757 18.685H10.542V34.6012ZM19.5232 22.6752H21.5475V30.7436H19.5232V22.6752Z",
    fill: "#00EC25"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenPassword);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GreenPassword.0dc0a0da1a56b7b306618d0d940ff1ff.svg";